import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { navConfigPropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import { SvgArrow } from 'components/Svgs';

function NavDropdownToggle(props) {
  const {
    toggleMenu,
    closeMenu,
    isOpen,
    isCollapsed,
    config: { message, icon, hasActiveChild },
  } = props;

  const classes = withMods('nav__dropdown-toggle', { 'is-active': hasActiveChild && !isOpen });

  useEffect(() => {
    if (isCollapsed || (isOpen && !hasActiveChild)) {
      closeMenu();
    }

    if (!isOpen && hasActiveChild && !isCollapsed) {
      toggleMenu();
    }
  }, [isCollapsed]);

  return (
    <button type="button" className={classes} onClick={toggleMenu}>
      {icon && (
        <div className="nav__dropdown-toggle-icon">
          <Isvg src={icon} />
        </div>
      )}
      {!isCollapsed && (
        <>
          <Message message={message} />
          <SvgArrow className="nav__dropdown-toggle-caret" direction={isOpen ? 'up' : 'down'} />
        </>
      )}
    </button>
  );
}

NavDropdownToggle.propTypes = {
  config: navConfigPropTypes,
  isCollapsed: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggleMenu: PropTypes.func,
  closeMenu: PropTypes.func,
};

export default NavDropdownToggle;
